var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M75 45H72.5C72.5 62.275 61.7 72.5 43.45 72.5C35.525 72.5 28.875 71.1 24.725 69.025L24.225 66.925L23.45 69.925L44.275 58.4C30.55 51.6 20.225 40.35 22.55 28.35L21.25 30.5L52.5 42.625V39.05C52.5 31.3 56.65 27.5 62.15 27.5C68.525 27.5 72.5 32.575 72.5 40H75C75 31.075 69.95 25 62.3 25C55.075 25 50 30.375 50 39L20 27.3C17.025 40.75 28.7 53.575 42.15 59.725L40.175 57.95L19.2 69.35C25.375 72.85 33.725 75 43.775 75C63.4 75 75 63.85 75 45ZM72.5 37.5V40H82.5V37.5H72.5Z","fill":"black"}));
}

Twitter.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
